/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Amount } from "./Amount";
import { Dettaglio } from "./Dettaglio";
import * as t from "io-ts";

// required attributes
const PaymentR = t.interface({});

// optional attributes
const PaymentO = t.partial({
  amount: Amount,

  bolloDigitale: t.boolean,

  detailsList: t.readonlyArray(Dettaglio, "array of Dettaglio"),

  email: t.string,

  fiscalCode: t.string,

  iban: t.string,

  id: t.Integer,

  idCarrello: t.string,

  idPayment: t.string,

  isCancelled: t.boolean,

  origin: t.string,

  receiver: t.string,

  subject: t.string,

  urlRedirectEc: t.string
});

export const Payment = t.intersection([PaymentR, PaymentO], "Payment");

export type Payment = t.TypeOf<typeof Payment>;
